export const T = {
  en_GB: {
    title: "Client preference tilt",
    description:
      "Each preference a client chooses adds a share of the portfolio to a product carrying it; the rest is scaled down to make room. 0 means no tilt for this dynamic portfolio.",
    save: "Save",
    saved: "Saved",
    failedToSave: "Failed to save the preference tilt",
  },
  nb_NO: {
    title: "Vridning mot klientpreferanser",
    description:
      "Hver preferanse en klient velger, legger en andel av porteføljen til et produkt som har den; resten skaleres ned for å gi plass. 0 betyr ingen vridning for denne dynamiske porteføljen.",
    save: "Lagre",
    saved: "Lagret",
    failedToSave: "Kunne ikke lagre vridningen mot preferanser",
  },
} as const;
